import { render, staticRenderFns } from "./ApplePay.vue?vue&type=template&id=45dc5c3a"
import script from "./ApplePay.vue?vue&type=script&lang=js"
export * from "./ApplePay.vue?vue&type=script&lang=js"
import style0 from "./ApplePay.vue?vue&type=style&index=0&id=45dc5c3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports